export const AGG_PREFIX = '_cdb_agg_';
export const DIM_PREFIX = '_cdb_dim_';
export const CLUSTER_FEATURE_COUNT = '_cdb_feature_count';
export const aggregationTypes = {
    AGGREGATED: 'aggregated',
    UNAGGREGATED: 'unaggregated',
    UNKNOWN: 'unknown'
};
